export type ServiceStatus = 'healthy' | 'degraded' | 'critical' | 'unknown' | 'ready'

export type RegionStatus = 'available' | 'limited' | 'unavailable' | 'unknown' | 'ready'

export const AVAILABILITY_STATUS: Record<number, RegionStatus> = {
  0: 'available',
  1: 'limited',
  2: 'unavailable',
  10: 'ready'
}

export const DEFAULT_REGION_STATUS: RegionStatus = 'unknown'

export const getRegionStatusFromCode = (code: number): RegionStatus => AVAILABILITY_STATUS[code] ?? DEFAULT_REGION_STATUS

export interface StatusData {
  services: Record<string, ServiceStatus>
  regionUrl?: string
  changeLists?: number[]
  supportLink?: string | null
}

export interface RegionAvailabilityFeed {
  Builds: Array<{
    GameMode: string
    ChangeLists: string[]
    Regions: Array<{
      Region: string
      Availability: number
    }>
  }>
}

export interface Rating {
  title: string
  slug: string
  image: string
  ageGate: number
  url: string
  locales: string[]
}
